import { useNavigate } from "react-router-dom";
import CreateBuildingPage from "../../quick-setup/create-building";

export default function ConfigCreateBuilding() {
  const navigate = useNavigate()
  
  return (
    <CreateBuildingPage onSuccess={() => {
      navigate(`/config/buildings`, { replace: true })
    }} />
  )
}